import { connect } from 'react-redux';

import { notificationsSelector } from '../../../../selectors';
import { markNotificationsSeen } from '../../../../actions/notification';
import NotificationList from './NotificationList';

const mapDispatchToProps = {
    markNotificationsSeen,
};

export function mapStateToProps(state) {
    const notifications = notificationsSelector(state);
    return {
        notifications,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);
